import React, { useState, useEffect } from 'react'
import { FaSearch } from 'react-icons/fa';
import { RiResetLeftFill } from "react-icons/ri";
import axiosInstance from '../utils/axios-instance';
import PromptList from './promptList';
import AddPromptModal from './addPromptModal';
import { toast } from 'sonner';

const ManagePrompts = () => {
    const [inputValue, setInputValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilter, setCurrentFilter] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [, setReload] = useState(false);

    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);

    const countPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                //   const response = await fetch(`/api/blogpost?page=${currentPage}&filter=${encodeURIComponent(currentFilter)}&search=${encodeURIComponent(searchQuery)}`, {
                //     cache: "no-store",
                //   });

                const res = await axiosInstance.get(`/prompt/getprompts?currentPage=${currentPage}&filter=${encodeURIComponent(currentFilter)}&search=${encodeURIComponent(searchQuery)}`);

                if (res.status === 200) {
                    setData(res.data.data);
                    setTotalPages(Math.ceil(res.data.totalCount / countPerPage));
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [searchQuery, currentFilter, currentPage]);

    const handleDeleteSuccess = (deletedUserId) => {
        setData(prev => prev.filter(user => user.id !== deletedUserId));
    };

    const handleEditSucess = () => {
        setReload(prev => !prev);   //force a page reload
    }   

    const resetFilters = () => {
        setInputValue('');
        setCurrentFilter('');
        setSearchQuery('');
        setCurrentPage(1);
    }

    const handleSearch = (e) => {
        const query = e.target.value;
        setInputValue(query);
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleSubmit = async (data) => {
        try {
            const res = await axiosInstance.post("/prompt/create", data);
            if (res.status === 200) {
                toast.success(res.data.message);
                setIsModalOpen(false);
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            // console.error(error.response.data.message); 
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    };

    const renderPageButtons = () => {
        const buttons = [];
        const maxVisibleButtons = 5;

        buttons.push(
            <button
                key={1}
                onClick={() => handlePageChange(1)}
                className={`px-3 py-1 mx-1 rounded ${currentPage === 1 ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
            >
                1
            </button>
        );

        let startPage = Math.max(2, currentPage - Math.floor(maxVisibleButtons / 2));
        let endPage = Math.min(totalPages - 1, startPage + maxVisibleButtons - 2);

        if (endPage - startPage < maxVisibleButtons - 2) {
            startPage = Math.max(2, endPage - maxVisibleButtons + 2);
        }

        if (startPage > 2) {
            buttons.push(<span key="ellipsis-1" className="px-2">...</span>);
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={`px-3 py-1 mx-1 rounded ${currentPage === i ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                >
                    {i}
                </button>
            );
        }

        if (endPage < totalPages - 1) {
            buttons.push(<span key="ellipsis-2" className="px-2">...</span>);
        }

        if (totalPages > 1) {
            buttons.push(
                <button
                    key={totalPages}
                    onClick={() => handlePageChange(totalPages)}
                    className={`px-3 py-1 mx-1 rounded ${currentPage === totalPages ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                >
                    {totalPages}
                </button>
            );
        }

        return buttons;
    };

    return (
        <div className="py-5">
            <div className="w-[90%] lg:w-[80%] mx-auto border border-gray-200 rounded-lg p-2 lg:p-6">
                <div className="flex justify-between items-center mb-5">
                    <h1 className="text-2xl font-bold mb-6 text-gray-800">Items List</h1>
                    <button
                        className="px-6 py-2 xxs:px-2 xxs:py-1 md:px-6 md:py-2  sm:px-6 sm:py-2  text-white  rounded-full shadow-lg border-2 bg-brandPrimary font-medium"
                        onClick={handleOpen}
                    >
                        Add Prompt
                    </button>
                </div>

                <div className="flex items-center justify-between w-full border-b border-gray-200 pb-2">
                    <div className="relative flex-grow max-w-xl">
                        <input
                            type="text"
                            value={inputValue}
                            onChange={handleSearch}
                            placeholder="Search prompts..."
                            className="block w-full pl-2 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <div onClick={() => setSearchQuery(inputValue)} className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center bg-gray-900">
                            <FaSearch className="h-4 w-4 text-gray-400" />
                        </div>
                    </div>

                    <div className="flex items-center space-x-2">

                        <button
                            onClick={() => resetFilters()}
                            className={`p-2 rounded-md bg-gray-900 text-white`}
                            aria-label="Grid view"
                        >
                            <RiResetLeftFill className="h-5 w-5" />
                        </button>

                    </div>

                </div>

                <div className="mb-6 min-h-64">
                    {loading ? (
                        <div className="flex justify-center items-center py-16">
                            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
                        </div>
                    ) : data.length > 0 ? (
                        <div>
                            <PromptList prompts={data} onDeleteSuccess={handleDeleteSuccess} onEditSuccess={handleEditSucess} />
                        </div>
                    ) : (
                        <div className="text-center py-8">
                            <p className="text-gray-500">No items found. Try adjusting your search or filter.</p>
                        </div>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="flex justify-center items-center my-4">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1 || loading}
                            className="px-4 py-2 mr-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Previous
                        </button>
                        <div className="flex items-center">{renderPageButtons()}</div>
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages || loading}
                            className="px-4 py-2 ml-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            <AddPromptModal
                isOpen={isModalOpen}
                onClose={handleClose}
                onSubmit={handleSubmit}
            />
        </div>
    );
}

export default ManagePrompts